"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.composeFilters = exports.getSalePrice = exports.canDiscountPassTimeRestriction = exports.getAvailableAutomaticDiscount = void 0;
const homi_shared_1 = require("@getgreenline/homi-shared");
const getAvailableAutomaticDiscount = ({ listing, discounts, categories, }) => {
    const { id: productId, categoryId } = listing;
    const automaticDiscounts = discounts.filter((discount) => discount.automatic);
    return automaticDiscounts.find((discount) => {
        // Products
        const excludeProductIds = discount.products.filter((p) => p.type === 'exclude').map((p) => p.id);
        const includeProductIds = discount.products.filter((p) => p.type === 'include').map((p) => p.id);
        if (excludeProductIds.length > 0) {
            if (excludeProductIds.includes(productId || '')) {
                return false;
            }
        }
        if (includeProductIds.length > 0) {
            if (!includeProductIds.includes(productId || '')) {
                return false;
            }
        }
        // Categories
        const excludeCategoryIds = [];
        const discountExcludeCategoryIds = discount.categories
            .filter((p) => p.type === 'exclude')
            .map((p) => p.id);
        discountExcludeCategoryIds.forEach((c) => {
            categories.forEach((fc) => {
                if (fc.id === c) {
                    excludeCategoryIds.push(fc.id);
                }
                else if (fc.parentCategoryId === c) {
                    excludeCategoryIds.push(fc.id);
                }
            });
        });
        const includeCategoryIds = [];
        const discountIncludeCategoryIds = discount.categories
            .filter((p) => p.type === 'include')
            .map((p) => p.id);
        discountIncludeCategoryIds.forEach((c) => {
            categories.forEach((fc) => {
                if (fc.id === c) {
                    includeCategoryIds.push(fc.id);
                }
                else if (fc.parentCategoryId === c) {
                    includeCategoryIds.push(fc.id);
                }
            });
        });
        if (excludeCategoryIds.length > 0 && categoryId) {
            if (excludeCategoryIds.includes(categoryId)) {
                return false;
            }
        }
        if (includeCategoryIds.length > 0) {
            if (!categoryId && !includeProductIds.includes(productId || '')) {
                return false;
            }
            if (categoryId && !includeCategoryIds.includes(categoryId)) {
                return false;
            }
        }
        // Time/Date
        if (!(0, exports.canDiscountPassTimeRestriction)(discount)) {
            return false;
        }
        return true;
    });
};
exports.getAvailableAutomaticDiscount = getAvailableAutomaticDiscount;
const canDiscountPassTimeRestriction = (discount) => {
    if (discount.applyDateRestriction) {
        if (discount.isRecurring) {
            // check days of the week
            const dayOfWeek = new Date().getDay();
            const dayOfWeekInString = homi_shared_1.mapDayOfWeek[dayOfWeek];
            if (!discount[dayOfWeekInString]) {
                return false;
            }
        }
        else {
            // check date range
            if (discount.startDate &&
                discount.endDate &&
                !(0, homi_shared_1.isBetweenTwoDates)(discount.startDate, discount.endDate)) {
                return false;
            }
        }
        // check time
        if (discount.startTime &&
            discount.endTime &&
            !(0, homi_shared_1.isBetweenTwoTimes)(discount.startTime, discount.endTime)) {
            return false;
        }
    }
    return true;
};
exports.canDiscountPassTimeRestriction = canDiscountPassTimeRestriction;
const getSalePrice = ({ listing, discounts, categories, }) => {
    const automaticDiscount = (0, exports.getAvailableAutomaticDiscount)({
        listing,
        discounts,
        categories,
    });
    if (!automaticDiscount) {
        return listing.price;
    }
    const discountAmount = automaticDiscount.type === homi_shared_1.DiscountTypes.PERCENT && listing.price
        ? listing.price * (automaticDiscount.amount / 100)
        : automaticDiscount.amount;
    return listing.price ? Math.round(listing.price - discountAmount) : null;
};
exports.getSalePrice = getSalePrice;
const composeFilters = (...fns) => (listing) => fns.reduce((acc, fn) => fn(acc), listing);
exports.composeFilters = composeFilters;
//# sourceMappingURL=posListingsWithFiltersHelpers.js.map